import patches from '@/util/intlPatches';
import { Fragment } from 'react';
import { useIntl } from 'react-intl';

const Price = props => {
  const { locale } = useIntl();
  const { value, currencyCode, classes = {} } = props;

  const newCurrency = {
    en: currencyCode,
    'de-DE': 'EUR',
    'en-US': 'USD',
  };

  const defaultLocale = process.env.NEXT_PUBLIC_DEFAULT_LOCALE;

  const parts = patches.toParts.call(
    new Intl.NumberFormat(defaultLocale, {
      style: 'currency',
      currency: currencyCode || newCurrency[locale],
    }),
    value,
  );

  const children = parts.map((part, i) => {
    const partClass = classes[part.type];
    const key = `${i}-${part.value}`;

    return (
      <span
        key={key}
        className={partClass}
      >
        {part.value}
      </span>
    );
  });

  return <Fragment>{children}</Fragment>;
};

export default Price;
